import React from 'react';
import { useRecoilValue } from 'recoil';
import { playerTableSelector } from '../../data/selectors';

export default function SelectedPlayers(props) {
    const playerTableState = useRecoilValue(playerTableSelector);

    return <span>{playerTableState.countSelectedRows ? `Selected ${playerTableState.countSelectedRows} items` : ''}</span>;
}